const tableCellOverrides = {
  styleOverrides: {
    root: {
      borderBottom: 'none',
    },
  },
};

export default tableCellOverrides;
